// extracted by mini-css-extract-plugin
module.exports = {"content":"SectionAccordion_content__mQp8l","layout--two-columns":"SectionAccordion_layout--two-columns__oFDEy","grid":"SectionAccordion_grid__oozBS"};